import { getPayments } from '../actions/payments.action';
import { connectWS } from '../middleware/sockets.funcs';
import { apiServices } from '../services/api.services';
import store from '../store';
import { setRedirect } from './rLink.action';
import { settingsInit } from './settings.action';

export const getInit = () => {
  return async (Dispatch) => {
    var {logged} = store.getState().rLink;
    if (logged) return true;
    var init = await apiServices.getInit();
    Dispatch({type: 'RLINK_SET_API_RESPONSED'});
    if (!init) {
      localStorage.getItem('i18nextLng') && store.dispatch({type: 'SET_LANG', locale: localStorage.getItem('i18nextLng')});
      if (!/bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.userAgent)) setRedirect('/home');
      return false;
    };
    init.uid && Dispatch({type: 'INIT_SET_UID', uid: init.uid});
    init.infos && Dispatch({type: 'INIT_SET_INFOS', infos: init.infos});
    init.guilds && Dispatch({type: 'SET_GUILDS', guilds: init.guilds});
    init.servers && Dispatch({type: 'SET_SERVERS', servers: init.servers});
    init.devices && Dispatch({type: 'SET_DEVICES', devices: init.devices});
    init.settings && settingsInit(Dispatch, init.settings);
    Dispatch({type: 'SET_INITED'});
    Dispatch(connectWS());
    getPayments();
    return true;
  };
};